var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyHeaderText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1232,
    height: 270,
    viewBox: "0 0 1232 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_42492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1106.37 142.835H1143.4L1168.44 194.295H1169.48L1194.69 142.835H1231.72L1185.47 228.369V268.702H1152.62V228.369L1106.37 142.835Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.22 184.211C1063.96 175.17 1056.48 169.955 1045.36 169.955C1027.8 169.955 1017.54 183.167 1017.54 205.594C1017.54 228.195 1027.1 241.581 1045.18 241.581C1060.92 241.581 1068.91 234.192 1069.17 222.458H1045.88V198.814H1101.16V216.025C1101.16 250.274 1077.69 270.44 1044.83 270.44C1008.33 270.44 983.465 245.754 983.465 205.942C983.465 164.565 1010.76 141.096 1044.66 141.096C1074.21 141.096 1096.99 159.002 1099.77 184.211H1066.22Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.166 205.768C968.166 247.666 941.393 270.44 907.318 270.44C872.896 270.44 846.297 247.492 846.297 205.768C846.297 163.87 872.896 141.096 907.318 141.096C941.393 141.096 968.166 163.87 968.166 205.768ZM934.091 205.768C934.091 182.646 924.529 169.955 907.318 169.955C889.933 169.955 880.372 182.646 880.372 205.768C880.372 228.89 889.933 241.581 907.318 241.581C924.529 241.581 934.091 228.89 934.091 205.768Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.635 268.702V142.835H786.666V241.93H837.952V268.702H753.635Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.469 205.768C737.469 247.666 710.696 270.44 676.621 270.44C642.199 270.44 615.6 247.492 615.6 205.768C615.6 163.87 642.199 141.096 676.621 141.096C710.696 141.096 737.469 163.87 737.469 205.768ZM703.394 205.768C703.394 182.646 693.832 169.955 676.621 169.955C659.236 169.955 649.674 182.646 649.674 205.768C649.674 228.89 659.236 241.581 676.621 241.581C693.832 241.581 703.394 228.89 703.394 205.768Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.432 142.835V268.702H571.79L525.024 200.727H524.155V268.702H491.123V142.835H519.287L565.357 210.463H566.4V142.835H599.432Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.605 268.702V142.835H394.637V192.382H441.055V142.835H474.26V268.702H441.055V219.155H394.637V268.702H361.605Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.059 189.6C311.016 177.778 303.019 169.955 289.633 169.955C272.248 169.955 262.338 183.341 262.338 205.768C262.338 229.412 272.422 241.581 289.459 241.581C302.15 241.581 310.321 234.627 312.059 223.501L345.613 223.848C343.874 245.406 324.924 270.44 288.764 270.44C254.167 270.44 228.264 247.492 228.264 205.768C228.264 163.87 254.863 141.096 288.764 141.096C320.057 141.096 342.831 158.655 345.613 189.6H312.059Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.869 268.702V142.835H211.75V169.608H154.901V192.382H207.056V219.155H154.901V241.93H211.576V268.702H121.869Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 169.608V142.835H108.483V169.608H70.5832V268.702H37.8993V169.608H0Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.414 28.5112V1.73828H747.897V28.5112H709.997V127.606H677.313V28.5112H639.414Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.893 127.606V1.73828H583.438C611.602 1.73828 630.03 19.471 630.03 45.8962C630.03 72.843 611.081 89.7065 582.395 89.7065H562.924V127.606H529.893ZM562.924 63.9767H575.789C588.306 63.9767 595.434 57.0226 595.434 45.8962C595.434 34.9437 588.306 28.1635 575.789 28.1635H562.924V63.9767Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.082 1.73828H410.285L440.187 74.9292H441.751L471.654 1.73828H512.856V127.606H480.52V53.5456H479.477L450.792 126.737H430.973L402.461 53.0241H401.418V127.606H369.082V1.73828Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.912 64.6723C352.912 106.57 326.139 129.345 292.064 129.345C257.642 129.345 231.043 106.396 231.043 64.6723C231.043 22.7744 257.642 0 292.064 0C326.139 0 352.912 22.7744 352.912 64.6723ZM318.837 64.6723C318.837 41.5502 309.276 28.8591 292.064 28.8591C274.679 28.8591 265.118 41.5502 265.118 64.6723C265.118 87.7943 274.679 100.485 292.064 100.485C309.276 100.485 318.837 87.7943 318.837 64.6723Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.826 127.606V1.73828H170.372C198.536 1.73828 216.964 17.7325 216.964 44.3316C216.964 61.7166 208.967 74.06 195.406 80.4924L221.136 127.606H185.149L162.896 85.7079H149.858V127.606H116.826ZM149.858 59.8042H162.723C175.24 59.8042 182.368 55.2841 182.368 44.3316C182.368 33.2052 175.24 28.1635 162.723 28.1635H149.858V59.8042Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65039 127.606V1.73828H57.1962C85.36 1.73828 103.788 19.471 103.788 45.8962C103.788 72.843 84.8384 89.7065 56.1531 89.7065H36.6819V127.606H3.65039ZM36.6819 63.9767H49.5468C62.064 63.9767 69.1919 57.0226 69.1919 45.8962C69.1919 34.9437 62.064 28.1635 49.5468 28.1635H36.6819V63.9767Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_42492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1232,
    height: 270,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyHeaderText);
export default __webpack_public_path__ + "static/media/company-header-text.2c8db779f6314a01bd2298e3ce52c6b5.svg";
export { ForwardRef as ReactComponent };